import React from 'react'
import 'date-fns';
import Grid from '@material-ui/core/Grid';
import DateFnsUtils from "@date-io/date-fns";

import esLocale from "date-fns/locale/es";

import {
    MuiPickersUtilsProvider,
    KeyboardDatePicker,
    KeyboardTimePicker
} from '@material-ui/pickers';


export const Calendar = ({setFieldValue}) => {
    const [selectedDate, setSelectedDate] = React.useState((new Date(Date.now())).toISOString());

    const handleTimeChange = (date,timeString) => {
        setFieldValue("time", timeString)
        setSelectedDate(date);
    };
    const handleDateChange = (date,timeString) => {
        setFieldValue("date", timeString)
        setSelectedDate(date);
    };
    return (
        <>
            <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
                <Grid container justifyContent="space-around">

                    <KeyboardDatePicker
                        margin="normal"
                        id="Date"
                        name="date"
                        label="Fecha de reserva"
                        format="dd/MM/yyyy"
                        value={selectedDate}
                        minDate={Date.now()}
                        minDateMessage="Debe seleccionar una fecha posterior al dia de hoy"
                        onChange={handleDateChange}
                        KeyboardButtonProps={{
                            'aria-label': 'change date',
                        }}
                    />
                    <KeyboardTimePicker
                        margin="normal"
                        id="Time"
                        name="time"
                        label="Horario de reserva"
                        value={selectedDate}
                        onChange={handleTimeChange}
                        KeyboardButtonProps={{
                            'aria-label': 'change time',
                        }}

                    />

                </Grid>


            </MuiPickersUtilsProvider>
        </>
    )
}
